const prod = {
  url: {
    API_URL: "https://cool-api-new.ogwebdesign.ca/api/",
    STORAGE_URL: "https://cool-api-new.ogwebdesign.ca/storage",
  },
};

const dev = {
  url: {
    API_URL: "http://localhost:8000/api/",
    STORAGE_URL: "http://localhost:8000/storage",
  },
};

export const config = process.env.NODE_ENV === "development" ? dev : prod;
